import styled from 'styled-components';
import {space, SpaceProps} from 'styled-system';

const Row = styled.div<SpaceProps>`
    ${space};
`

export default Row